/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassignaction2Inputs */

const en_partnersassignaction2 = /** @type {(inputs: Partnersassignaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

const de_partnersassignaction2 = /** @type {(inputs: Partnersassignaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuordnen`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Partnersassignaction2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassignaction2 = /** @type {((inputs?: Partnersassignaction2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassignaction2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassignaction2(inputs)
	return de_partnersassignaction2(inputs)
});
export { partnersassignaction2 as "partnersAssignAction" }